import type { JSX } from 'react';

import { ClosingCta } from '../features/marketing/closing-cta.js';
import { Faq } from '../features/marketing/faq.js';
import { Hero, InsuranceBand, PersonalizedSupport } from '../features/marketing/hero.js';
import { Testimonials } from '../features/marketing/testimonials.js';
import { HowItWorks, MoreThanVisits, WhyNourishedRx } from '../features/marketing/why-and-steps.js';

/**
 * Story 1.1 — public FFS-MNT landing page.
 *
 * Section-for-section parity with https://www.nourishedrx.com/dietitian-support so a member arriving
 * from the marketing site sees the same page, with every CTA routed to this app's own eligibility
 * check (see `EligibilityCta`) rather than the legacy hosted form.
 */
export default function LandingPage(): JSX.Element {
  return (
    <div className="flex flex-col">
      <Hero />
      <InsuranceBand />
      <PersonalizedSupport />
      <WhyNourishedRx />
      <HowItWorks />
      <MoreThanVisits />
      <ClosingCta />
      <Testimonials />
      <Faq />
    </div>
  );
}
